<template lang="pug">
modal#invite-limit-reached-modal(
  :close='close'
  :close-button-label='$t("modal.inviteUserLimit.close")'
  :loading='loading'
  :process-button-label='$t("modal.inviteUserLimit.process")'
  :title='$t("modal.inviteUserLimit.title")'
  @closed='onClosed'
  @opened='onOpen'
  @process='handleUpgrade'
  ref='modal'
)
  p {{ getDescriptionInviteLimit() }}
  p {{ getDescriptionUpdatePlan() }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'InviteLimitReachedModal',
  components: { Modal },
  data() {
    return {
      loading: false,
      close: false,
    };
  },
  methods: {
    resetState() {
      this.loading = false;
      this.close = false;
    },

    open() {
      this.resetState();
      this.$refs.modal.open();
    },

    onOpen() {
      this.resetState();
    },

    onClosed() {
      this.resetState();
    },

    handleUpgrade() {
      this.loading = true;
      this.$router.push('/account/billing/plan');
      this.close = true;
    },

    getDescriptionInviteLimit() {
      return this.$t('modal.inviteUserLimit.descriptionLimit');
    },

    getDescriptionUpdatePlan() {
      return this.$t('modal.inviteUserLimit.descriptionUpdatePlan');
    },
  },
};
</script>

<style scoped>
/* */
</style>
